//font
export const DEFAULT_FONTFAMILY = '"Facto", Arial, Helvetica, sans-serif';
//export const MEDIUM_FONTFAMILY = '"Facto Medium", Arial, Helvetica, sans-serif'; currently not used
